<head>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>



<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="row" style="margin-bottom: 5px;">
  <div class="col-md-6">
    <app-breadcrumb></app-breadcrumb>
  </div>
  <div class="col-md-6">
    <div class=" button-continer">
      <button mat-stroked-button class="cancelButton" (click)="back()" style="float: right;">Cancel</button>
      <button mat-stroked-button class="addButton" (click)="createScheduleFunc('Trigger Now')"
        style="margin-right: 1%;float: right;">Trigger Now</button>
      <button *ngIf="schedulerData.status =='Not Scheduled'" mat-stroked-button class="addButton"
        (click)="createScheduleFunc('Create Schedule')" style="margin-right: 1%;float: right;">Create Schedule</button>
      <button *ngIf="schedulerData.status =='Scheduled'" mat-stroked-button class="addButton"
        (click)="cancelScheduleFunc()" style="margin-right: 1%;float: right;">Cancel Schedule</button>


    </div>
  </div>
</div>

<div class="table-container form-content">
  <div id="serach-field-container">
    <div class="row">
      <div class="col-md-2">
        <div><label for="email">Scheduler Name</label></div>
        <input class="input-filed-continers" type="text" [(ngModel)]="schedulerData.schedulerName" disabled>
      </div>
      <div class="col-md-2">
        <div><label for="email">Status</label></div>
        <input class="input-filed-continers" type="text" [(ngModel)]="schedulerData.status" disabled>
      </div>
      <div class="col-md-2">
        <div><label for="email">Enabled</label></div>
        <input class="input-filed-continers" type="text" [(ngModel)]="schedulerData.enabled" disabled>
      </div>
      <div class="col-md-2">
        <div><label for="email">Start Date:</label></div>
        <div>
          <input id="scheduleStartDate" type="text" class="form-control data-picker-continer" bsDatepicker
            [bsConfig]="dateTimePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="schedulerData.startDate" disabled>
        </div>
      </div>
      <div class="col-md-2">
        <div><label for="email">Repeat Interval</label></div>
        <input class="input-filed-continers" type="text" [(ngModel)]="schedulerData.repeatInterval" disabled>
      </div>
      <div class="col-md-2">
        <div><label for="email">End Date:</label></div>
        <div>
          <input id="scheduleEndDate" type="text" class="form-control data-picker-continer" bsDatepicker
            [bsConfig]="dateTimePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="schedulerData.endDate" disabled>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2">
        <div><label for="email">Run Count</label></div>
        <input class="input-filed-continers" type="text" [(ngModel)]="schedulerData.runCount" disabled>
      </div>
      <div class="col-md-2">
        <div><label for="email">Failure Count</label></div>
        <input class="input-filed-continers" type="text" [(ngModel)]="schedulerData.failureCount" disabled>
      </div>
      <div class="col-md-2">
        <div><label for="email">Last Start Date:</label></div>
        <div>
          <input id="scheduleLastStartDate" type="text" class="form-control data-picker-continer" bsDatepicker
            [bsConfig]="dateTimePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="schedulerData.lastStartDate" disabled>
        </div>
      </div>
      <div class="col-md-2">
        <div><label for="email">Next Run Date:</label></div>
        <div>
          <input id="scheduleNextRunDate" type="text" class="form-control data-picker-continer" bsDatepicker
            [bsConfig]="dateTimePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="schedulerData.nextRunDate" disabled>
        </div>
      </div>
      <div class="col-md-2">
        <div><label for="email">Job Type</label></div>
        <input class="input-filed-continers" type="text" [(ngModel)]="schedulerData.jobType" disabled>
      </div>
      <div class="col-md-2">
        <div><label for="email">Schedule Type</label></div>
        <input class="input-filed-continers" type="text" [(ngModel)]="schedulerData.scheduleType" disabled>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2">
        <div><label for="email">Job Action</label></div>
        <input class="input-filed-continers" type="text" [(ngModel)]="schedulerData.jobAction" disabled>
      </div>
      <div class="col-md-2">
        <div><label for="email">NSL Env</label></div>
        <input class="input-filed-continers" type="text" [(ngModel)]="schedulerData.nlsEnv" disabled>
      </div>
    </div>
  </div>
</div>
<br>

<div class="position-relative grid-content" style="margin-top: 10px;">
  <div>
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center px-3">
        <div class="gridName-container subcontent-heading">
          <span class="gridName">Job Runs</span>
        </div>
      </div>
      <div class="d-flex gap-3">
        <div id="header-container">
          <div class="">
            <div class="search-container">
              <span class="fa fa-search form-control-feedback"></span>
              <input type="text" class="form-control search_input" style="font-size: 12px" placeholder="Search here..."
                [(ngModel)]="searchValue" />
            </div>
          </div>
        </div>
        <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="refreshGridData()" (keydown.enter)="refreshGridData()">
          <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
          <span class="reload_text">Reload</span>
        </div>
      </div>
    </div>
  </div>
  <div class="table-container">
    <table class="dynamic-table-container">
      <th style="min-width: 60px; text-align: center;"
        [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
        <div style="display: flex;">
          <div>
            <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
          </div>
        </div>
      </th>
      <th id="grid-header-container"
        *ngFor="let scheduledTrainingDataForGrid of columnLists.fieldColumnarray; let ix = index;"
        [ngStyle]="{'min-width': scheduledTrainingDataForGrid.width}"
        class="sticky-dynamic-col1 dynamic-table-header-style" (mouseover)="cssfunction(0)" (focus)="focusEmpty()">

        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
          <span>{{ scheduledTrainingDataForGrid.fieldColumnarray }}</span>
          <div class="d-flex gap-2 align-items-center">
            <div (click)="sortColumn(columnLists.columnsListarray[ix],scheduledTrainingDataForGrid)"
              (keydown.enter)="sortColumn(columnLists.columnsListarray[ix],scheduledTrainingDataForGrid)">
              <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
            </div>
          </div>
        </div>
      </th>
      <th id="menu" class="sticky-col first-col"></th>
      <tr>
        <td [class]="  makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' "></td>
        <td *ngFor=" let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index "
          [ngStyle]="{ 'min-width': oneQmsUsersDataForTable1Data.width != null ? oneQmsUsersDataForTable1Data.width : '200px' }"
          class="sticky-dynamic-col1" (mouseover)="cssfunction(0)" (focus)="focusEmpty()">
          <div class="row-search-container"><input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter3(columnLists.columnsListarray[ix], $event)" /> </div>
        </td>
      </tr>
      <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;"
        [class.highlightRow]="list.childCheckBoxs == true">
        <td style="min-width: 60px; text-align: center;"
          [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
          <div style="display: flex;">
            <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </div>
            <div>
              <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBoxs"
                (change)="dataGridChildCheckBoxChecked($event, list, idx)">
            </div>
          </div>
        </td>
        <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
          class="sticky-dynamic-row1" [ngStyle]="{
                'max-width': key.width[i],
                'overflow': 'hidden',
                'text-overflow': 'ellipsis',
                'white-space': 'nowrap',
                'cursor': 'pointer'}" matTooltip="{{ list[key.columnsListarray] }}" (mouseover)="cssfunction(i)"
          (focus)="focusEmpty()">
          <span *ngIf="key.dataType=='CHECKBOX'">
            <div class="gridCheckBoxes">
              <img alt="access" *ngIf="list[key.columnsListarray]" src="../../../assets/img/accessSymbol.svg" width="20"
                height="20">
              <img alt="noaccess" *ngIf="list[key.columnsListarray]==false" src="../../../assets/img/noAcessSymbol.svg"
                width="20" height="20">
            </div>
          </span>
          <span *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE'">{{ list[key.columnsListarray] }}</span>
          <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
        </td>
      </tr>
    </table>
    <div class="d-flex justify-content-center">
      <div class="width-cheat small paginationCell">
        <div class="d-flex align-items-center gap-3">
          <div class="pagination_text mt-3">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSize | number }}
          </div>
          <div>
            <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
              [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
              [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
          </div>
          <div ngbDropdown class="mt-3">
            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1" ngbDropdownToggle>
              {{ perPage }}
              <i class="ms-1 fa-solid fa-chevron-down"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <button ngbDropdownItem (click)="paginationCall(10)">10</button>
              <button ngbDropdownItem (click)="paginationCall(20)">20</button>
              <button ngbDropdownItem (click)="paginationCall(50)">50</button>
            </div>
            per page
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #cancelSchedulePopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelCancelScheduleFunc()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>

    <div mat-dialog-title>
      <label for="pop" class="popupTitle"> Cancel Schedule</label>
      <label for="poptitle" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div id="filed-container" class="form-continer" style="height: auto !important;">

      <div class="row" style="margin-left: 8%;">
        Are you sure, you want to cancel Schedule?
      </div>

      <br>
      <div class="button-continer" mat-dialog-actions>
        <button mat-stroked-button class="addButton" (click)="cancelScheduleOkFunc()">
          OK
        </button>
        <button mat-stroked-button class="cancelButton" (click)="cancelCancelScheduleFunc()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #createSchedulePopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelCreateScheduleFunc()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>

    <div mat-dialog-title>
      <label for="popup" class="popupTitle"> {{title}} </label>
      <label for="popuptitle" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 10px;">
      <div>
        <div class="row" [hidden]="title != 'Create Schedule'">
          <div class="col-md-3"><label for="email">Scheduled Start Date</label><span class="mandatory-symbol">*</span>
          </div>
          <div class="col-md-9"> <input id="scheduledStartDate" type="text" class="form-control data-picker-continer"
              [minDate]="todayDate" bsDatepicker [bsConfig]="dateTimePickerConfiguration"
              [dateCustomClasses]="dateCustomClasses" [(ngModel)]="scheduledStartDate"
              (ngModelChange)="setVal(scheduledStartDate)">
            <span id="scheduledStartDate-required-msg">Please select the scheduled start date</span>
          </div>
        </div>
        <br [hidden]="title != 'Create Schedule'">
        <div class="row" [hidden]="title != 'Create Schedule'">
          <div class="col-md-3"><label for="email">Scheduled End Date</label><span class="mandatory-symbol">*</span>
          </div>
          <div class="col-md-9"> <input id="scheduledEndDate" type="text" class="form-control data-picker-continer"
              bsDatepicker [bsConfig]="dateTimePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
              [(ngModel)]="scheduledEndDate" [minDate]="minEndDate" (ngModelChange)="setEndVal(scheduledEndDate)">
            <span id="scheduledEndDate-required-msg">Please select the scheduled end date</span>
          </div>
        </div>
        <br [hidden]="title != 'Create Schedule'">
        <div class="row" [hidden]="title != 'Create Schedule'">
          <div class="col-md-3"><label for="email">Scheduled Interval</label><span class="mandatory-symbol">*</span>
          </div>
          <div class="col-md-9">
            <mat-select matInput placeholder="Select" id="scheduledInterval" [(ngModel)]="selectedSchedulerOption"
              (closed)="scheduledIntervalsearchTxt=''" (click)="focusmethod('scheduledIntervalfocusSearch')"
              (keydown.enter)="focusmethod('scheduledIntervalfocusSearch')">
              <input type="search" id="scheduledIntervalfocusSearch" class="dropdownsearchstyle"
                [(ngModel)]="scheduledIntervalsearchTxt" matInput placeholder="Search">
              <mat-option class="unselectStyle" [value]="null"
                (onSelectionChange)="onSchedulerOptionSelect($event,null);">Un-select</mat-option>
              <mat-option *ngFor="let item of schedulerOptionDropdown | assessmentSearch :scheduledIntervalsearchTxt"
                (onSelectionChange)="onSchedulerOptionSelect($event,item)" [value]="item.valueExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
            <span id="scheduledInterval-required-msg">Please select the scheduled interval</span>
          </div>
        </div>
        <br [hidden]="title != 'Create Schedule'">
        <div class="row" [hidden]="title != 'Create Schedule'">
          <div class="col-md-3"></div>
          <div class="col-md-9">
            <input type="text" class="input-filed-continers" [(ngModel)]="this.selectedSchedulerOptionValue">
          </div>
        </div>
        <br [hidden]="title != 'Create Schedule'">
        <div class="row" [hidden]="title == 'Create Schedule'">
          <div class="col-md-12 text-center">
            Are you sure, you want to trigger now?
          </div>

        </div>
      </div>
    </div>
    <div class="button-continer" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="createScheduleOkFunc()">
        OK
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelCreateScheduleFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>